import { render, staticRenderFns } from "./tableEntityDiff.vue?vue&type=template&id=cddbf34a&scoped=true"
import script from "./tableEntityDiff.vue?vue&type=script&lang=js"
export * from "./tableEntityDiff.vue?vue&type=script&lang=js"
import style0 from "./tableEntityDiff.vue?vue&type=style&index=0&id=cddbf34a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddbf34a",
  null
  
)

export default component.exports